import i18n from '@/i18n'

/**
 * 切换语言
 * @param {string} locale - 语言代码 'zh-cn' | 'en' | 'zh-tw'
 */
export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
  
  // Element Plus 的语言会通过 ElConfigProvider 在 App.vue 中自动同步
  // 不需要在这里返回语言包
}

/**
 * 获取当前语言
 * @returns {string} 当前语言代码
 */
export function getLocale() {
  return i18n.global.locale.value
}

/**
 * 获取翻译文本
 * @param {string} key - 翻译键
 * @param {object} params - 参数对象
 * @returns {string} 翻译后的文本
 */
export function t(key, params = {}) {
  return i18n.global.t(key, params)
}

export default i18n

